var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("About asdasdasd")]),_c('button',{on:{"click":function($event){return _vm.$router.push('/user')}}},[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }